export const LANG = {
  cs: 'cs',
  en: 'en'
}

export const WCM_PORTALS = {
  INTERNET: 'internet'
}

export const USER_AUTH_COOKIE = 'csasauxid'

export const REGEXPS = {
  NAME: /^(?=.{2,50}$)([a-zěščřžýáíéúůďťňóöüäĺľôŕA-ZĚŠČŘŽÝÁÍÉÚŮĎŤŇÓÖÄÜĹĽÔŔ-]+)(\s[a-zěščřžýáíéúůďťňóöüäĺľôŕA-ZĚŠČŘŽÝÁÍÉÚŮĎŤŇÓÖÄÜĹĽÔŔ-]+)?(\s[a-zěščřžýáíéúůďťňóöüäĺľôŕA-ZĚŠČŘŽÝÁÍÉÚŮĎŤŇÓÖÄÜĹĽÔŔ-]+)?$/,
  PHONE_CZSK: /^\+(420|421)\d{9}$/,
  PHONE_GENERAL: /^\+\d{8,15}$/,
  EMAIL: /^[a-zA-Z0-9._@%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  NON_SPECIAL_CHARACTERS: /^[a-zA-ZěščřžýáíéúůďťňóöüäĺľôŕĚŠČŘŽÝÁÍÉÚŮĎŤŇÓÖÄÜĹĽÔŔ\s.-]+$/,
  TITLE: /^[a-zA-Z0-9 ,.:'"!?-]*$/,
  ICO: /^\d{0,8}$/,
  DATE: /^[0-9\s.]*$/,
  NUMBER: /^\d+$/
}

export const PATTERNS = {
  EMAIL: /^[a-zA-Z0-9.@_-]*$/,
  PHONE: /^\+\d{0,15}$/
}

export const DIALLING_CODE = {
  CZ: '+420',
  SK: '+421'
}
